import { ISelectOption } from "@/components/form/fields/SelectField";

export abstract class EnumUtil {
  static toOptions(): ISelectOption[] {
    return Object.entries(this).map(([value, label]) => ({
      value,
      label,
    }));
  }

  static valueOf(value: string): string {
    const result = Object.entries(this).find(([, val]) => val === value);
    if (result) return result[0];

    throw new Error("Value not found");
  }
}
